<template>
  <div>
    <div class="h-dialogContainer" >
      <template>
        <ParseForm ref="basic" :formId="formItems.basic.formId" :formParams="formItems.basic.formObj" :opCode="opCode" :funcClick="bindClickInterface" :funcOnChange="changeOdbStatus"></ParseForm>
      </template>
      <ProfileList ref='profileList' :getCheckedDatas='getCheckedList' ></ProfileList>
    </div>
  </div>
</template>

<script>
import ParseForm from '../../../util/parseFormNew/ParseForm';
import ProfileList from "./ProfileList";
import SubscriberTool from '../../../util/parseFormNew/tools/subscriberTool';
import ajaxUrl from "../../../data/ajaxUrl";
import { EventBus } from '../../../../../plugins/eventBus';

export default {
  name: "AddBatchUserForm",
  components: {
    ParseForm,
    ProfileList,
  },
  methods: {
    getDatas() {
      const map = new Map();
      if (this.$refs.basic) {
        if (!this.$refs.basic.validateResult()) {
          return;
        }
        const maps = this.$refs.basic.getDatas();
        for (const [key, value] of maps.entries()) {
          map.set(key, value);
        }
      }
      console.log(map);
      return map;
    },
    getJson(ne, callback) {
      this.ne = ne;
      const params = {
        msgid: this.msgId,
        neid: ne.neid,
      };
      this.$axios.post(ajaxUrl.addBatchUserJson, params).then(response => {
        if (!response) {
          console.log("getJson response error");
          return;
        }
        if (!response.data) {
          console.log("getJson response.data error");
          return;
        }
        if (!response.data.resultVal) {
          console.log("getJson response.data.resultVal error");
          return;
        }
        if (response.data.errorCode !== "0") {
          console.log("getJson response.data.errorCode error");
          callback(response);
          return;
        }
        const res = response.data.resultVal;
        const sub = new SubscriberTool();
        const resultMap = sub.$devideByGroupBy(res, []);
        this.formItems.basic.formObj = resultMap.get(this.formItems.basic.modelName);
        callback(response);
      });
    },
    saveBatchUser(ne, callback) {
      const formData = this.getDatas();
      const startImsi = formData.get("imsi");
      const opCount = formData.get("opCount");
      const addUserList = [];
      if(parseInt(formData.get("imsi")) + parseInt(opCount) - 1 > 999999999999999){
        EventBus.$emit('toast', {type: 'warning', content: this.$t("LteUser.exceedImsi")});
        return;
      }
      if(parseInt(formData.get("msisdn")) + parseInt(opCount) - 1 > 99999999999){
        EventBus.$emit('toast', {type: 'warning', content: this.$t("LteUser.exceedMsisdn")});
        return;
      }
      for (let i=0; i<opCount; i++) {
        addUserList.push({
          imsi: (Number(startImsi) + i).toString(),
        })
      }
      if (formData) {
        const params = {
          vo: {
            "neid": ne.neid,
            "isBatch": "1",
            "grpid": "0",
            "imsi_odb": formData.get("imsi_status") === 1 ? formData.get("imsi_odb") : '',
            "imsi": formData.get("imsi"),
            "msisdn": formData.get("msisdn"),
            "opCount": formData.get("opCount"),
            "k": formData.get("k"),
            "amf": formData.get("amf"),
            "op": formData.get("op"),
            "imsi_status": formData.get("imsi_status"),
            "profile_id": formData.get("profile_id"),
            "staAddrConfig": [],
            "randKeyFlg": formData.get("randKeyFlg"),
          },
          info: {
            msgid: this.msgId,
            neid: ne.neid,
          },
          log: {
            module: 'res.subscriber#res.subscriber_lte#res.subscriber_lte_user',
            execFunName: 'subscriber.batchaddUser',
            exectype: 1,
            execData: addUserList
          }
        };
        this.$loading.showLoadding(this.$t('LteUser.batchAddUserTip'),this.$t('SubscriberIms.waitTip'));
        this.$axios.post(ajaxUrl.requestCommon, params).then((response) => {
          this.$loading.hideLoadding();
          if (callback) {
            callback(response, addUserList);
          }
        });
      }
    },
    getCheckedList(list) {
      if(this.$refs.basic) {
        this.$refs.basic.setData('profile_id', list[0] || '');
      }
    },
    onclickProfileId() {
      this.$refs.profileList.qryList(this.ne);
      this.$refs.profileList.show();
    },
    // 随机生成checkbox
    $checkBoxStateFunc(...paramName) {
      const _resArr = [];
      const $this = this;
      if (paramName.length === 0) return;
      _resArr[0] = () => {
        paramName.forEach((item) => {
          const dom = document.getElementById(item);
          if (dom !== null) {
            dom.nextElementSibling.classList.add('h-red-code');
            dom.nextElementSibling.innerHTML = '*';
          }
          $this.$refs.basic.setAttrByName(item, 'disabled', false);
          $this.$refs.basic.setReadonlyNoGray(item);
        });
      };
      _resArr[1] = () => {
        paramName.forEach((item) => {
          const dom = document.getElementById(item);
          if (dom !== null && dom.nextElementSibling.className === 'h-red-code') {
            dom.nextElementSibling.classList.remove('h-red-code');
            dom.nextElementSibling.innerHTML = '';
          }
          try{
            let domName = document.getElementsByName(item);
            domName[0].classList.remove("e-error");
            domName[0].nextElementSibling.style.display = 'none';
          } catch(e) {
            console.log('没有找到节点');
          }
          $this.$refs.basic.setAttrByName(item, 'disabled', true);
          $this.$refs.basic.setReadonlyNoGray(item);
        });
      };
      return _resArr;
    },
    // 绑定
    changeOdb() {
      const newValue = this.$refs.basic.getAttrByName('imsi_status', 'value');
      if (newValue === 1) {
        this.$refs.basic.setAttrByName('imsi_odb', 'readonly', false);
      } else {
        this.$refs.basic.setAttrByName('imsi_odb', 'readonly', true);
      }
    }
  },
  computed: {
    bindClickInterface() {
      this.funcMap = new Map();
      this.funcMap.set('profile_id', () => { this.onclickProfileId(); });
      const _resMap = new Map();
      _resMap.set(0, this.$checkBoxStateFunc('k'));

      this.funcMap.set('randKeyFlg', _resMap);
      return this.funcMap;
    },
    changeOdbStatus() {
      this.funcMap3 = new Map();
      this.funcMap3.set('imsi_status', this.changeOdb);
      return this.funcMap3;
    }
  },
  data() {
    return {
      ne: null,
      id: 0,
      funcMap: null,
      funcMap3: null,
      list: [
      ],
      formItems: {
        basic: {
          formId: "LteAddBatchBasicInfo",
          modelName: "basic",
          formObj: null,
        },
      },
      opCode: "add",
      msgId: "17066",
      timer1: null,
    };
  },
  beforeDestroy() {
  }
};
</script>
